import React from 'react';

import styles from './personalisation-footer.module.css';

/**
 * The "Current Total:" row: label, price and, when `onViewSummary` is given, the chevron that opens
 * the summary. Shared by the journey footer and the photo editor's footer.
 *
 * @param {Object} props - Component props
 * @param {string} props.price - The formatted total, e.g. "£109.00"
 * @param {function} [props.onViewSummary] - Opens the summary; no chevron when omitted
 * @param {boolean} [props.summaryOpen] - Whether the summary is open (for aria-expanded)
 * @param {import('react').ReactNode} [props.children] - Rendered last inside the row (the footer's summary modal)
 * @returns {import('react').JSX.Element}
 */
export function PersonalisationTotal({ price, onViewSummary, summaryOpen = false, children }) {
  return (
    <div className={styles['personalisation__footer-detail']}>
      <p className={styles['personalisation__footer-detail-label'] + ' body-base'}>Current Total:</p>
      <p className={styles['personalisation__footer-detail-price'] + ' body-lg font-medium'}>{price}</p>
      {onViewSummary && (
        <button
          type="button"
          className={styles['personalisation__footer-summary-control'] + ' button-reset'}
          onClick={onViewSummary}
          aria-label="View summary"
          aria-haspopup="dialog"
          aria-expanded={summaryOpen}
        >
          <span className="svg-wrapper" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.294 7.205a.417.417 0 0 1 0 .59l-5 5a.417.417 0 0 1-.589 0l-5-5a.417.417 0 1 1 .59-.59L10 11.911l4.705-4.706a.417.417 0 0 1 .59 0Z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </button>
      )}
      {children}
    </div>
  );
}
